"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeopleBasicOrderFields = exports.PeopleBasicFields = exports.PeopleRoleFilter = void 0;
var PeopleRoleFilter;
(function (PeopleRoleFilter) {
    PeopleRoleFilter["OWNER"] = "owner";
    PeopleRoleFilter["BOOKKEEPER"] = "bookkeeper";
    PeopleRoleFilter["REVIEWER"] = "reviewer";
    PeopleRoleFilter["MEMBER"] = "member";
    PeopleRoleFilter["INVITEE"] = "invitee";
    PeopleRoleFilter["BOOKKEEPER_EXTENDED"] = "bookkeeper-extended";
    PeopleRoleFilter["BOOKKEEPER_BASIC"] = "bookkeeper-basic";
})(PeopleRoleFilter = exports.PeopleRoleFilter || (exports.PeopleRoleFilter = {}));
var PeopleBasicFields;
(function (PeopleBasicFields) {
    PeopleBasicFields["FIRST_NAME"] = "firstName";
    PeopleBasicFields["LAST_NAME"] = "lastName";
    PeopleBasicFields["EMAIL"] = "email";
    PeopleBasicFields["PHONE"] = "phone";
    PeopleBasicFields["TYPE"] = "type";
    PeopleBasicFields["ROLE"] = "role";
    PeopleBasicFields["DEPARTMENTS"] = "departments";
})(PeopleBasicFields = exports.PeopleBasicFields || (exports.PeopleBasicFields = {}));
var PeopleBasicOrderFields;
(function (PeopleBasicOrderFields) {
    PeopleBasicOrderFields["FIRST_NAME"] = "firstName";
    PeopleBasicOrderFields["LAST_NAME"] = "lastName";
})(PeopleBasicOrderFields = exports.PeopleBasicOrderFields || (exports.PeopleBasicOrderFields = {}));
//# sourceMappingURL=people.js.map